import { render, staticRenderFns } from "./PriceForm.vue?vue&type=template&id=0733e29c&scoped=true"
import script from "./PriceForm.vue?vue&type=script&lang=js"
export * from "./PriceForm.vue?vue&type=script&lang=js"
import style0 from "./PriceForm.vue?vue&type=style&index=0&id=0733e29c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733e29c",
  null
  
)

export default component.exports